/* eslint-disable
    @typescript-eslint/no-unused-vars,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const Auth = require('app/scripts/db/auth');
const Promise = require('bluebird');
const xtend = require('xtend');
const $ = require('jquery');
const { slackTrelloDomain } = require('@trello/config');

const slackKey = '7737388dfc54ea015104894e3a0a56f9';
const token = '';

const createPromise = (opts) =>
  new Promise(function (resolve, reject) {
    opts = xtend(opts, {
      success(...args) {
        resolve(args);
      },
      error(...args) {
        reject(args);
      },
    });
    $.ajax(opts);
  });
module.exports.ajaxTrello = function (opts) {
  opts.url = slackTrelloDomain + opts.url;

  if (opts.data == null) {
    opts.data = {};
  }
  opts.data.cookie = document.cookie;
  return createPromise(opts);
};
